import { mdiBookmarkOutline } from '@mdi/js'
import Icon from '@mdi/react'

import { Box } from '@/components/ui/box'
import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { ISource } from '@/types/gigiChat/Source'

const Source = ({ icon = mdiBookmarkOutline, link, iconSize = '16px', text }: ISource) => {
    const defaultColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')

    return (
        <Box display="inline-flex" alignItems="center" mr="8px">
            <Icon path={icon} size={iconSize} color={defaultColor} />
            <Link data-id="chat-source-link" href={link} isExternal textDecor="underline" textAlign="left" ml="4px">
                <Text as="span" fontSize="14px" letterSpacing="0.25px">
                    {text}
                </Text>
            </Link>
        </Box>
    )
}

export default Source
